/* "Barrel" of Http Interceptors */
import { HTTP_INTERCEPTORS } from "@angular/common/http";

import { AuthInterceptor } from "./auth-interceptor";
import { ErrorInterceptor } from "./error-interceptor";
import { JwtInterceptor } from "@auth0/angular-jwt";

/** Http interceptor providers in outside-in order */
export const httpInterceptorProviders = [
  // Providing JwtInterceptor allow to inject JwtInterceptor manually into ErrorInterceptor
  JwtInterceptor,
  {
    provide: HTTP_INTERCEPTORS,
    useExisting: JwtInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: AuthInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: ErrorInterceptor,
    multi: true,
  },
];



// WEBPACK FOOTER //
// ./src/providers/http-interceptors/index.ts